import { forwardRef } from "react";

import { useArticleSpeechInlineWidgetContext } from "~/components/article/article-speech/article-speech-inline-widget/contexts";
import { useArticleSpeechContext } from "~/components/article/article-speech/contexts";
import { sendGATracking } from "~/components/tracking/google-analytics/apis";

import { HeadphoneIcon } from "./headphone-icon";
import {
  MainContainer,
  MinifyContainer,
  RegularContainer,
  StyledArrowRightIcon,
  StyledCloseIcon,
  Text,
} from "./styles";

type Props = {
  isMinify: boolean;
};

export const ArticleSpeechInlineWidgetGenericButton = forwardRef<HTMLDivElement, Props>(
  ({ isMinify = false, ...props }, reference) => {
    const { isPlayed } = useArticleSpeechInlineWidgetContext();
    const { handleClosePlayer } = useArticleSpeechContext();

    const handleRenderHeadphoneIcon = () => <HeadphoneIcon isPlayed={isPlayed} />;
    const handleRenderMinifyUI = () =>
      isPlayed ? (
        <MinifyContainer>{handleRenderHeadphoneIcon()}</MinifyContainer>
      ) : (
        <MinifyContainer>
          <Text>Listen</Text>
          {handleRenderHeadphoneIcon()}
        </MinifyContainer>
      );

    const handleRenderRegularUI = () =>
      isPlayed ? (
        <RegularContainer>
          {handleRenderHeadphoneIcon()}
          <Text>Listening...</Text>
          <StyledCloseIcon
            onClick={() => {
              handleClosePlayer?.();
              sendGATracking({
                action: "TTS/Close",
                category: "TTS",
                label: "",
              });
            }}
          />
        </RegularContainer>
      ) : (
        <RegularContainer>
          {handleRenderHeadphoneIcon()}
          <Text>Listen to this article</Text>
          <StyledArrowRightIcon />
        </RegularContainer>
      );
    return (
      <MainContainer {...props} $isPlayed={isPlayed} ref={reference}>
        {isMinify ? handleRenderMinifyUI() : handleRenderRegularUI()}
      </MainContainer>
    );
  },
);

ArticleSpeechInlineWidgetGenericButton.displayName = "ArticleSpeechInlineWidgetGenericButton";
